import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setAttempts,
  setDateTime,
  setMethod,
  setSuccessfulAttempt,
} from '../../procedures/medicalConsult/store/medicalConsult.actions'
import { setAddMedicalConsultToTimeline } from '../store/quickActions.actions'
import { getMedicalConsultOptionsSelector, getVitalOptionsSelector } from '../../options/selectors'
import { IMedicalConsultOptionsState, IVitalOptionsState } from '../../options/store/options.types'
import { IOption } from '../../../common/common.types'

export function* setMedicalConsultQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate, procedureAction } = props
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  const { methodOptions }: IMedicalConsultOptionsState = yield select(getMedicalConsultOptionsSelector)
  const methodOption = methodOptions.find((option: IOption) => option.name === procedureAction)

  yield put(setDateTime(savedTimeString, currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
  yield put(setSuccessfulAttempt(true))
  yield put(setAttempts('1'))
  yield put(setMethod(methodOption ? methodOption : null))
  yield put(setAddMedicalConsultToTimeline(true))
}

export function* setMedicalConsultQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_MEDICAL_CONSULT_BUTTON_TYPE], setMedicalConsultQuickAction)
}
